<template>
  <div
    id="email-recipient-form"
  >
    <email-nav
      v-if="isEmail"
      :emailId="emailId"
    />

    <h2>
      {{ actionLbl }} {{ displayName }} Recipient
    </h2>

    <form
      method="post"
      v-on:submit.prevent="submit"
    >
      <div class="form-group">
        <label
          for="attrName('recipient_email')"
        >
          Recipient Email Address
        </label>

        <input
          type="email"
          class="form-control"
          :name="attrName('recipient_email')"
          :id="attrName('recipient_email')"
          :value="recipient.recipient_email"
        />
      </div>
      <div
        class="form-group"
      >
        <queued-at
          labelText="Queued At"
          :name="attrName('queued_at')"
          :value="recipient.queued_at"
        />

        <send-at
          labelText="Send At"
          :name="attrName('send_at')"
          :value="recipient.send_at"
        />

        <sent-at
          labelText="Sent At"
          :name="attrName('sent_at')"
          :value="recipient.sent_at"
        />

        <last-delivered-at
          labelText="Last Delivered At"
          :name="attrName('last_delivered_at')"
          :value="recipient.last_delivered_at"
        />

        <last-bounced-at
          labelText="Last Bounced At"
          :name="attrName('last_bounced_at')"
          :value="recipient.last_bounced_at"
        />
      </div>

      <input
        type="hidden"
        :name="attrName('id')"
        :value="recipient.id"
        v-if="recipient.id"
      />

      <div
        class="form-check form-group"
        v-if="isEmail"
      >
        <input
          type="checkbox"
          class="form-check-input"
          id="email_recipient_resend"
          name="email_recipient[resend]"
        >

        <label
          class="form-check-label"
          for="email_recipient_resend"
        >
          Force a resend
        </label>

        <p
          class="alert alert-warning text-center"
        >
          Only necessary if the user has already been queued, or the email has already been delivered to the user.
        </p>
      </div>

      <input
        type="hidden"
        :name="relationalId"
        :value="emailId"
        v-if="emailId"
      />

      <div
        class="form-group"
      >
        <button
          type="submit"
          class="btn btn-block btn-primary"
        >
          {{ !emailRecipientId ? 'Add' : 'Update' }} Recipient
        </button>
      </div>
    </form>
  </div>
</template>
<script>
import EmailMixin from '@/mixins/EmailMixin'

import Datetime from '@/components/Datetime'
import EmailNav from '@/components/EmailNav'
import FlashStore from '@/stores/FlashStore'

import { mapState } from 'vuex'

export default {
  computed: mapState({
    actionLbl () {
      return this.baseId ? 'New' : 'Update'
    },

    recipientModelName () {
      return this.relationalIdName + '_recipient'
    },

    relationalId () {
      return this.attrName(this.relationalIdName + '_id')
    },

    recipient: state => state.EmailModule.emailRecipient
  }),

  components: {
    'email-nav': EmailNav,
    'queued-at': Datetime,
    'send-at': Datetime,
    'sent-at': Datetime,
    'last-bounced-at': Datetime,
    'last-delivered-at': Datetime
  },

  mixins: [
    EmailMixin
  ],

  props: {
    emailRecipientId: {
      type: [ Number, String ],
      default: undefined
    }
  },

  created () {
    if (this.emailRecipientId) {
      this.get()
    }
  },

  methods: {
    attrName (attr) {
      return this.recipientModelName + `[${attr}]`
    },

    get () {
      this.$store.dispatch(
        `EmailModule/getEmailRecipient`,
        {
          newsletterId: this.newsletterId,
          recipientId: this.emailRecipientId
        }
      ).catch(this.$root.processErrors)
    },

    submit (ev) {
      this.$store.dispatch(
        `EmailModule/createEmailRecipient`, new FormData(ev.target)
      ).then((resp) => {
        FlashStore.result('Recipient has been added.')
      }).catch(this.$root.processErrors)
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/EmailRecipientForm.vue